import ErrorBoundary from "../components/ErrorBoundary";

/**
 * Minimal game wrapper for standalone mode.
 * Zero chrome: no header, no sidebar, no footer, no lobby nav.
 * Renders children in a full-viewport container.
 */
const StandaloneOutlet = ({ children }) => (
  <ErrorBoundary>
    <main
      style={{
        width: "100vw",
        minHeight: "100vh",
        overflow: "visible",
        margin: 0,
        padding: 0,
      }}
    >
      {children}
    </main>
  </ErrorBoundary>
);

export default StandaloneOutlet;
